export default __webpack_public_path__ + "static/media/Orc_lair.67b80eaf.png";